import {
  protoOf180f3jzyo7rfj as protoOf,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  plus1ogy4liedzq5j as plus,
  toMutableSetjdpdbr9jsqq8 as toMutableSet,
  ArrayList_init_$Create$2qnngtk1et9r9 as ArrayList_init_$Create$,
  Unit_instance104q5opgivhr8 as Unit_instance,
  VOID7hggqo3abtya as VOID,
  Exceptiondt2hlxn7j7vw as Exception,
  Exception_init_$Init$32vb8wlewqrmh as Exception_init_$Init$,
  captureStack1fzi4aczwc4hg as captureStack,
  CoroutineImpl2sn3kjnwmfr10 as CoroutineImpl,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  isInterface3d6p8outrmvmk as isInterface,
  toString1pkumu07cwy4m as toString,
  Collection1k04j3hzsbod0 as Collection,
  emptyList1g2z5xcrvp2zy as emptyList,
  getKClassFromExpression3vpejubogshaw as getKClassFromExpression,
  Unitkvevlwgzwiuc as Unit,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  equals2au1ep9vhcato as equals,
  joinToString1cxrrlmo0chqs as joinToString,
  initMetadataForCoroutine1i7lbatuf5bnt as initMetadataForCoroutine,
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  ArrayList_init_$Create$1s1wkrw82c0iw as ArrayList_init_$Create$_0,
  PrimitiveClasses_getInstance28ukyr6i8fs0q as PrimitiveClasses_getInstance,
  getKClass1s3j9wy1cofik as getKClass,
  setOf45ia9pnfhe90 as setOf,
  KtList3hktaavzmj137 as KtList,
  arrayOf1akklvh2at202 as arrayOf,
  createKType1lgox3mzhchp5 as createKType,
  createInvariantKTypeProjection3sfd0u0y62ozd as createInvariantKTypeProjection,
  endsWith3cq61xxngobwh as endsWith,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  LinkedHashSet_init_$Create$3qv13l7kzf0ni as LinkedHashSet_init_$Create$,
} from './kotlin-kotlin-stdlib.mjs';
import {
  Application_getInstance1d4ly18wdhadx as Application_getInstance,
  contentType317fn4f991q9a as contentType,
  HttpHeaders_getInstancekqele34vb34f as HttpHeaders_getInstance,
  Companion_getInstance2t5xhismubxj4 as Companion_getInstance,
  OutgoingContent3t2ohmyam9o76 as OutgoingContent,
  contentType2zzm38yxo3syt as contentType_0,
  charset1dribv3ku48b1 as charset,
  NullBody_instance9oj4j8z4op1j as NullBody_instance,
  HttpStatusCode3o1wkms10pg4k as HttpStatusCode,
  ContentType1svlpabm9v7iz as ContentType,
} from './ktor-ktor-http.mjs';
import {
  register$default2n93tkqtk1ptz as register$default,
  Configuration20xgygxdzhlk5 as Configuration,
  suitableCharset1jgdcpdzbzgzn as suitableCharset,
  deserialize17rec5pkkk30w as deserialize,
} from './ktor-ktor-shared-ktor-serialization.mjs';
import {
  Charsets_getInstancemd62gu5po4os as Charsets_getInstance,
  ByteReadChannel2wzou76jce72d as ByteReadChannel,
} from './ktor-ktor-io.mjs';
import {
  TransformRequestBodyContext3ll40opqaho0d as TransformRequestBodyContext,
  HttpRequestBuilder15f2nnx9sjuv1 as HttpRequestBuilder,
  TransformResponseBodyContext1axf7xx6ifwbj as TransformResponseBodyContext,
  HttpResponse1532ob1hsse1y as HttpResponse,
  get_request3dwcif5y0fvf1 as get_request,
  accept2gi3b7wj4jds9 as accept,
  EmptyContent_getInstance14idgfcuyuug as EmptyContent_getInstance,
  createClientPluginjwpvufjows5r as createClientPlugin,
} from './ktor-ktor-client-ktor-client-core.mjs';
import {
  TypeInfo2nbxsuf4v8os2 as TypeInfo,
  KtorSimpleLogger1xdphsp5l4e48 as KtorSimpleLogger,
  AttributeKey3aq8ytwgx54f7 as AttributeKey,
} from './ktor-ktor-utils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
initMetadataForClass(ConverterRegistration, 'ConverterRegistration');
initMetadataForClass(ContentNegotiationConfig$defaultMatcher$1);
initMetadataForClass(ContentNegotiationConfig, 'ContentNegotiationConfig', ContentNegotiationConfig, VOID, [Configuration]);
initMetadataForClass(ContentConverterException, 'ContentConverterException', VOID, Exception);
initMetadataForLambda(ContentNegotiation$lambda$slambda, CoroutineImpl, VOID, [4]);
initMetadataForLambda(ContentNegotiation$lambda$slambda_1, CoroutineImpl, VOID, [4]);
initMetadataForCoroutine($invoke$convertRequestCOROUTINE$0, CoroutineImpl);
initMetadataForCoroutine($invoke$convertResponseCOROUTINE$1, CoroutineImpl);
initMetadataForObject(JsonContentTypeMatcher, 'JsonContentTypeMatcher');
//endregion
function get_LOGGER() {
  _init_properties_ContentNegotiation_kt__o183go();
  return LOGGER;
}
var LOGGER;
function get_DefaultCommonIgnoredTypes() {
  _init_properties_ContentNegotiation_kt__o183go();
  return DefaultCommonIgnoredTypes;
}
var DefaultCommonIgnoredTypes;
function get_ExcludedContentTypes() {
  _init_properties_ContentNegotiation_kt__o183go();
  return ExcludedContentTypes;
}
var ExcludedContentTypes;
function get_ContentNegotiation() {
  _init_properties_ContentNegotiation_kt__o183go();
  return ContentNegotiation;
}
var ContentNegotiation;
function ConverterRegistration(converter, contentTypeToSend, contentTypeMatcher) {
  this.b6b_1 = converter;
  this.c6b_1 = contentTypeToSend;
  this.d6b_1 = contentTypeMatcher;
}
function defaultMatcher($this, pattern) {
  return new ContentNegotiationConfig$defaultMatcher$1(pattern);
}
function ContentNegotiationConfig$defaultMatcher$1($pattern) {
  this.e6b_1 = $pattern;
}
protoOf(ContentNegotiationConfig$defaultMatcher$1).f6b = function (contentType) {
  return contentType.w3w(this.e6b_1);
};
function ContentNegotiationConfig() {
  this.g6b_1 = toMutableSet(plus(get_DefaultIgnoredTypes(), get_DefaultCommonIgnoredTypes()));
  var tmp = this;
  // Inline function 'kotlin.collections.mutableListOf' call
  tmp.h6b_1 = ArrayList_init_$Create$();
  this.i6b_1 = null;
}
protoOf(ContentNegotiationConfig).f4n = function (contentType, converter, configuration) {
  var matcher = contentType.w3w(Application_getInstance().c3v_1) ? JsonContentTypeMatcher_instance : defaultMatcher(this, contentType);
  this.j6b(contentType, converter, matcher, configuration);
};
protoOf(ContentNegotiationConfig).j6b = function (contentTypeToSend, converter, contentTypeMatcher, configuration) {
  // Inline function 'kotlin.apply' call
  configuration(converter);
  var registration = new ConverterRegistration(converter, contentTypeToSend, contentTypeMatcher);
  this.h6b_1.e(registration);
};
function ContentConverterException(message) {
  Exception_init_$Init$(message, this);
  captureStack(this, ContentConverterException);
}
function ContentNegotiationConfig$_init_$ref_1ne3ob() {
  var l = function () {
    return new ContentNegotiationConfig();
  };
  l.callableName = '<init>';
  return l;
}
function ContentNegotiation$lambda($this$createClientPlugin) {
  _init_properties_ContentNegotiation_kt__o183go();
  var registrations = $this$createClientPlugin.a50_1.h6b_1;
  var ignoredTypes = $this$createClientPlugin.a50_1.g6b_1;
  $this$createClientPlugin.n5h(ContentNegotiation$lambda$slambda_0(registrations, $this$createClientPlugin, ignoredTypes, null));
  $this$createClientPlugin.j5b(ContentNegotiation$lambda$slambda_2(ignoredTypes, registrations, $this$createClientPlugin, null));
  return Unit_instance;
}
function invoke$convertRequest(registrations, $this_createClientPlugin, ignoredTypes, request, body, $completion) {
  var tmp = new $invoke$convertRequestCOROUTINE$0(registrations, $this_createClientPlugin, ignoredTypes, request, body, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
}
function invoke$convertResponse(ignoredTypes, registrations, $this_createClientPlugin, requestUrl, info, body, responseContentType, charset, $completion) {
  charset = charset === VOID ? Charsets_getInstance().n3n_1 : charset;
  var tmp = new $invoke$convertResponseCOROUTINE$1(ignoredTypes, registrations, $this_createClientPlugin, requestUrl, info, body, responseContentType, charset, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
}
function ContentNegotiation$lambda$slambda($registrations, $this_createClientPlugin, $ignoredTypes, resultContinuation) {
  this.h6d_1 = $registrations;
  this.i6d_1 = $this_createClientPlugin;
  this.j6d_1 = $ignoredTypes;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(ContentNegotiation$lambda$slambda).o6d = function ($this$transformRequestBody, request, body, _unused_var__etf5q3, $completion) {
  var tmp = this.p6d($this$transformRequestBody, request, body, _unused_var__etf5q3, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(ContentNegotiation$lambda$slambda).o5c = function (p1, p2, p3, p4, $completion) {
  var tmp = p1 instanceof TransformRequestBodyContext ? p1 : THROW_CCE();
  var tmp_0 = p2 instanceof HttpRequestBuilder ? p2 : THROW_CCE();
  var tmp_1 = !(p3 == null) ? p3 : THROW_CCE();
  return this.o6d(tmp, tmp_0, tmp_1, (p4 == null ? true : p4 instanceof TypeInfo) ? p4 : THROW_CCE(), $completion);
};
protoOf(ContentNegotiation$lambda$slambda).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 2;
          this.n8_1 = 1;
          suspendResult = invoke$convertRequest(this.h6d_1, this.i6d_1, this.j6d_1, this.l6d_1, this.m6d_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          return suspendResult;
        case 2:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 2) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
protoOf(ContentNegotiation$lambda$slambda).p6d = function ($this$transformRequestBody, request, body, _unused_var__etf5q3, completion) {
  var i = new ContentNegotiation$lambda$slambda(this.h6d_1, this.i6d_1, this.j6d_1, completion);
  i.k6d_1 = $this$transformRequestBody;
  i.l6d_1 = request;
  i.m6d_1 = body;
  i.n6d_1 = _unused_var__etf5q3;
  return i;
};
function ContentNegotiation$lambda$slambda_0($registrations, $this_createClientPlugin, $ignoredTypes, resultContinuation) {
  var i = new ContentNegotiation$lambda$slambda($registrations, $this_createClientPlugin, $ignoredTypes, resultContinuation);
  var l = function ($this$transformRequestBody, request, body, _unused_var__etf5q3, $completion) {
    return i.o6d($this$transformRequestBody, request, body, _unused_var__etf5q3, $completion);
  };
  l.$arity = 4;
  return l;
}
function ContentNegotiation$lambda$slambda_1($ignoredTypes, $registrations, $this_createClientPlugin, resultContinuation) {
  this.y6d_1 = $ignoredTypes;
  this.z6d_1 = $registrations;
  this.a6e_1 = $this_createClientPlugin;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(ContentNegotiation$lambda$slambda_1).m5c = function ($this$transformResponseBody, response, body, info, $completion) {
  var tmp = this.n5c($this$transformResponseBody, response, body, info, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(ContentNegotiation$lambda$slambda_1).o5c = function (p1, p2, p3, p4, $completion) {
  var tmp = p1 instanceof TransformResponseBodyContext ? p1 : THROW_CCE();
  var tmp_0 = p2 instanceof HttpResponse ? p2 : THROW_CCE();
  var tmp_1 = (!(p3 == null) ? isInterface(p3, ByteReadChannel) : false) ? p3 : THROW_CCE();
  return this.m5c(tmp, tmp_0, tmp_1, p4 instanceof TypeInfo ? p4 : THROW_CCE(), $completion);
};
protoOf(ContentNegotiation$lambda$slambda_1).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 2;
          var tmp_0 = this;
          var tmp0_elvis_lhs = contentType(this.c6e_1);
          var tmp_1;
          if (tmp0_elvis_lhs == null) {
            return null;
          } else {
            tmp_1 = tmp0_elvis_lhs;
          }

          tmp_0.f6e_1 = tmp_1;
          this.g6e_1 = suitableCharset(get_request(this.c6e_1).e41());
          this.n8_1 = 1;
          suspendResult = invoke$convertResponse(this.y6d_1, this.z6d_1, this.a6e_1, get_request(this.c6e_1).b4u(), this.e6e_1, this.d6e_1, this.f6e_1, this.g6e_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          return suspendResult;
        case 2:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 2) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
protoOf(ContentNegotiation$lambda$slambda_1).n5c = function ($this$transformResponseBody, response, body, info, completion) {
  var i = new ContentNegotiation$lambda$slambda_1(this.y6d_1, this.z6d_1, this.a6e_1, completion);
  i.b6e_1 = $this$transformResponseBody;
  i.c6e_1 = response;
  i.d6e_1 = body;
  i.e6e_1 = info;
  return i;
};
function ContentNegotiation$lambda$slambda_2($ignoredTypes, $registrations, $this_createClientPlugin, resultContinuation) {
  var i = new ContentNegotiation$lambda$slambda_1($ignoredTypes, $registrations, $this_createClientPlugin, resultContinuation);
  var l = function ($this$transformResponseBody, response, body, info, $completion) {
    return i.m5c($this$transformResponseBody, response, body, info, $completion);
  };
  l.$arity = 4;
  return l;
}
function ContentNegotiation$lambda$convertRequest$lambda(it) {
  _init_properties_ContentNegotiation_kt__o183go();
  return toString(it.b6b_1);
}
function $invoke$convertRequestCOROUTINE$0(registrations, $this_createClientPlugin, ignoredTypes, request, body, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.s6b_1 = registrations;
  this.t6b_1 = $this_createClientPlugin;
  this.u6b_1 = ignoredTypes;
  this.v6b_1 = request;
  this.w6b_1 = body;
}
protoOf($invoke$convertRequestCOROUTINE$0).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 7;
          var tmp_0 = this;
          var tmp_1;
          if (this.v6b_1.u4r_1.u3o(get_ExcludedContentTypes())) {
            var excluded = this.v6b_1.u4r_1.s3o(get_ExcludedContentTypes());
            var tmp0 = this.s6b_1;
            var destination = ArrayList_init_$Create$();
            var _iterator__ex2g4s = tmp0.j();
            while (_iterator__ex2g4s.k()) {
              var element = _iterator__ex2g4s.l();
              var tmp$ret$0;
              l$ret$1: do {
                var tmp_2;
                if (isInterface(excluded, Collection)) {
                  tmp_2 = excluded.p();
                } else {
                  tmp_2 = false;
                }
                if (tmp_2) {
                  tmp$ret$0 = true;
                  break l$ret$1;
                }
                var _iterator__ex2g4s_0 = excluded.j();
                while (_iterator__ex2g4s_0.k()) {
                  var element_0 = _iterator__ex2g4s_0.l();
                  if (element.c6b_1.w3w(element_0)) {
                    tmp$ret$0 = false;
                    break l$ret$1;
                  }
                }
                tmp$ret$0 = true;
              }
               while (false);
              if (tmp$ret$0) {
                destination.e(element);
              }
            }
            tmp_1 = destination;
          } else {
            tmp_1 = this.s6b_1;
          }

          tmp_0.x6b_1 = tmp_1;
          var tmp_3 = this;
          var tmp0_elvis_lhs = this.v6b_1.r4r_1.g3q(HttpHeaders_getInstance().b3x_1);
          tmp_3.y6b_1 = tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
          var _iterator__ex2g4s_1 = this.x6b_1.j();
          while (_iterator__ex2g4s_1.k()) {
            var element_1 = _iterator__ex2g4s_1.l();
            var tmp0_0 = this.y6b_1;
            var tmp$ret$2;
            l$ret$3: do {
              var tmp_4;
              if (isInterface(tmp0_0, Collection)) {
                tmp_4 = tmp0_0.p();
              } else {
                tmp_4 = false;
              }
              if (tmp_4) {
                tmp$ret$2 = true;
                break l$ret$3;
              }
              var _iterator__ex2g4s_2 = tmp0_0.j();
              while (_iterator__ex2g4s_2.k()) {
                var element_2 = _iterator__ex2g4s_2.l();
                if (Companion_getInstance().zl(element_2).w3w(element_1.c6b_1)) {
                  tmp$ret$2 = false;
                  break l$ret$3;
                }
              }
              tmp$ret$2 = true;
            }
             while (false);
            if (tmp$ret$2) {
              var qValue = this.t6b_1.a50_1.i6b_1;
              var contentTypeToSend = qValue == null ? element_1.c6b_1 : element_1.c6b_1.u3w('q', qValue.toString());
              get_LOGGER().o3u('Adding Accept=' + contentTypeToSend.toString() + ' header for ' + this.v6b_1.p4r_1.toString());
              accept(this.v6b_1, contentTypeToSend);
            }
          }

          var tmp_5;
          var tmp_6 = this.w6b_1;
          if (tmp_6 instanceof OutgoingContent) {
            tmp_5 = true;
          } else {
            var tmp5 = this.u6b_1;
            var tmp$ret$4;
            l$ret$5: do {
              var tmp_7;
              if (isInterface(tmp5, Collection)) {
                tmp_7 = tmp5.p();
              } else {
                tmp_7 = false;
              }
              if (tmp_7) {
                tmp$ret$4 = false;
                break l$ret$5;
              }
              var _iterator__ex2g4s_3 = tmp5.j();
              while (_iterator__ex2g4s_3.k()) {
                var element_3 = _iterator__ex2g4s_3.l();
                if (element_3.qa(this.w6b_1)) {
                  tmp$ret$4 = true;
                  break l$ret$5;
                }
              }
              tmp$ret$4 = false;
            }
             while (false);
            tmp_5 = tmp$ret$4;
          }

          if (tmp_5) {
            get_LOGGER().o3u('Body type ' + toString(getKClassFromExpression(this.w6b_1)) + ' is in ignored types. ' + ('Skipping ContentNegotiation for ' + this.v6b_1.p4r_1.toString() + '.'));
            return null;
          }

          var tmp_8 = this;
          var tmp0_elvis_lhs_0 = contentType_0(this.v6b_1);
          var tmp_9;
          if (tmp0_elvis_lhs_0 == null) {
            this.t6b_1;
            get_LOGGER().o3u("Request doesn't have Content-Type header. Skipping ContentNegotiation for " + this.v6b_1.p4r_1.toString() + '.');
            return null;
          } else {
            tmp_9 = tmp0_elvis_lhs_0;
          }

          tmp_8.z6b_1 = tmp_9;
          var tmp_10 = this.w6b_1;
          if (tmp_10 instanceof Unit) {
            get_LOGGER().o3u('Sending empty body for ' + this.v6b_1.p4r_1.toString());
            this.v6b_1.r4r_1.u3q(HttpHeaders_getInstance().t3x_1);
            return EmptyContent_getInstance();
          }

          var tmp_11 = this;
          var tmp0_1 = this.s6b_1;
          var destination_0 = ArrayList_init_$Create$();
          var _iterator__ex2g4s_4 = tmp0_1.j();
          while (_iterator__ex2g4s_4.k()) {
            var element_4 = _iterator__ex2g4s_4.l();
            if (element_4.d6b_1.f6b(this.z6b_1)) {
              destination_0.e(element_4);
            }
          }

          var tmp_12;
          if (!destination_0.p()) {
            tmp_12 = destination_0;
          } else {
            tmp_12 = null;
          }

          var tmp1_elvis_lhs = tmp_12;
          var tmp_13;
          if (tmp1_elvis_lhs == null) {
            this.t6b_1;
            get_LOGGER().o3u('None of the registered converters match request Content-Type=' + this.z6b_1.toString() + '. ' + ('Skipping ContentNegotiation for ' + this.v6b_1.p4r_1.toString() + '.'));
            return null;
          } else {
            tmp_13 = tmp1_elvis_lhs;
          }

          tmp_11.a6c_1 = tmp_13;
          if (this.v6b_1.w5j() == null) {
            get_LOGGER().o3u('Request has unknown body type. Skipping ContentNegotiation for ' + this.v6b_1.p4r_1.toString() + '.');
            return null;
          }

          this.v6b_1.r4r_1.u3q(HttpHeaders_getInstance().t3x_1);
          var tmp_14 = this;
          tmp_14.b6c_1 = this.a6c_1;
          this.n8_1 = 1;
          continue $sm;
        case 1:
          this.d6c_1 = this.b6c_1;
          this.e6c_1 = this.d6c_1.j();
          this.n8_1 = 2;
          continue $sm;
        case 2:
          if (!this.e6c_1.k()) {
            this.n8_1 = 5;
            continue $sm;
          }

          this.f6c_1 = this.e6c_1.l();
          var tmp_15 = this;
          tmp_15.g6c_1 = this.f6c_1;
          this.h6c_1 = this.g6c_1;
          this.n8_1 = 3;
          var tmp0_elvis_lhs_1 = charset(this.z6b_1);
          var tmp_16 = tmp0_elvis_lhs_1 == null ? Charsets_getInstance().n3n_1 : tmp0_elvis_lhs_1;
          var tmp_17 = ensureNotNull(this.v6b_1.w5j());
          var this_0 = this.w6b_1;
          var tmp_18;
          if (!equals(this_0, NullBody_instance)) {
            tmp_18 = this_0;
          } else {
            tmp_18 = null;
          }

          suspendResult = this.h6c_1.b6b_1.h6e(this.z6b_1, tmp_16, tmp_17, tmp_18, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 3:
          var result = suspendResult;
          if (!(result == null)) {
            get_LOGGER().o3u('Converted request body using ' + toString(this.h6c_1.b6b_1) + ' for ' + this.v6b_1.p4r_1.toString());
          }

          var result_0 = result;
          if (!(result_0 == null)) {
            this.c6c_1 = result_0;
            this.n8_1 = 6;
            continue $sm;
          } else {
            this.n8_1 = 4;
            continue $sm;
          }

        case 4:
          this.n8_1 = 2;
          continue $sm;
        case 5:
          this.c6c_1 = null;
          if (false) {
            this.n8_1 = 1;
            continue $sm;
          }

          this.n8_1 = 6;
          continue $sm;
        case 6:
          var tmp2_elvis_lhs = this.c6c_1;
          var tmp_19;
          if (tmp2_elvis_lhs == null) {
            var tmp_20 = "Can't convert " + toString(this.w6b_1) + ' with contentType ' + this.z6b_1.toString() + ' using converters ';
            throw new ContentConverterException(tmp_20 + joinToString(this.a6c_1, VOID, VOID, VOID, VOID, VOID, ContentNegotiation$lambda$convertRequest$lambda));
          } else {
            tmp_19 = tmp2_elvis_lhs;
          }

          var serializedContent = tmp_19;
          return serializedContent;
        case 7:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 7) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
function $invoke$convertResponseCOROUTINE$1(ignoredTypes, registrations, $this_createClientPlugin, requestUrl, info, body, responseContentType, charset, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.q6c_1 = ignoredTypes;
  this.r6c_1 = registrations;
  this.s6c_1 = $this_createClientPlugin;
  this.t6c_1 = requestUrl;
  this.u6c_1 = info;
  this.v6c_1 = body;
  this.w6c_1 = responseContentType;
  this.x6c_1 = charset;
}
protoOf($invoke$convertResponseCOROUTINE$1).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 2;
          var tmp_0 = this.v6c_1;
          if (!isInterface(tmp_0, ByteReadChannel)) {
            get_LOGGER().o3u('Response body is already transformed. Skipping ContentNegotiation for ' + this.t6c_1.toString() + '.');
            return null;
          }

          if (this.q6c_1.u1(this.u6c_1.k3u_1)) {
            get_LOGGER().o3u('Response body type ' + toString(this.u6c_1.k3u_1) + ' is in ignored types. ' + ('Skipping ContentNegotiation for ' + this.t6c_1.toString() + '.'));
            return null;
          }

          var tmp_1 = this;
          var tmp0 = this.r6c_1;
          var destination = ArrayList_init_$Create$();
          var _iterator__ex2g4s = tmp0.j();
          while (_iterator__ex2g4s.k()) {
            var element = _iterator__ex2g4s.l();
            if (element.d6b_1.f6b(this.w6c_1)) {
              destination.e(element);
            }
          }

          var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(destination, 10));
          var _iterator__ex2g4s_0 = destination.j();
          while (_iterator__ex2g4s_0.k()) {
            var item = _iterator__ex2g4s_0.l();
            destination_0.e(item.b6b_1);
          }

          var tmp_2;
          if (!destination_0.p()) {
            tmp_2 = destination_0;
          } else {
            tmp_2 = null;
          }

          var tmp0_elvis_lhs = tmp_2;
          var tmp_3;
          if (tmp0_elvis_lhs == null) {
            this.s6c_1;
            get_LOGGER().o3u('None of the registered converters match response with Content-Type=' + this.w6c_1.toString() + '. ' + ('Skipping ContentNegotiation for ' + this.t6c_1.toString() + '.'));
            return null;
          } else {
            tmp_3 = tmp0_elvis_lhs;
          }

          tmp_1.y6c_1 = tmp_3;
          this.n8_1 = 1;
          suspendResult = deserialize(this.y6c_1, this.v6c_1, this.u6c_1, this.x6c_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          var result = suspendResult;
          if (!isInterface(result, ByteReadChannel)) {
            get_LOGGER().o3u('Response body was converted to ' + toString(getKClassFromExpression(result)) + ' for ' + this.t6c_1.toString() + '.');
          }

          return result;
        case 2:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 2) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
var properties_initialized_ContentNegotiation_kt_1ayduy;
function _init_properties_ContentNegotiation_kt__o183go() {
  if (!properties_initialized_ContentNegotiation_kt_1ayduy) {
    properties_initialized_ContentNegotiation_kt_1ayduy = true;
    LOGGER = KtorSimpleLogger('io.ktor.client.plugins.contentnegotiation.ContentNegotiation');
    DefaultCommonIgnoredTypes = setOf([PrimitiveClasses_getInstance().zb(), PrimitiveClasses_getInstance().vb(), getKClass(HttpStatusCode), getKClass(ByteReadChannel), getKClass(OutgoingContent)]);
    // Inline function 'io.ktor.util.AttributeKey' call
    var name = 'ExcludedContentTypesAttr';
    // Inline function 'io.ktor.util.reflect.typeInfo' call
    var tmp = getKClass(KtList);
    // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
    var tmp_0;
    try {
      tmp_0 = createKType(getKClass(KtList), arrayOf([createInvariantKTypeProjection(createKType(getKClass(ContentType), arrayOf([]), false))]), false);
    } catch ($p) {
      var tmp_1;
      if ($p instanceof Error) {
        var _unused_var__etf5q3 = $p;
        tmp_1 = null;
      } else {
        throw $p;
      }
      tmp_0 = tmp_1;
    }
    var tmp$ret$0 = tmp_0;
    var tmp$ret$1 = new TypeInfo(tmp, tmp$ret$0);
    ExcludedContentTypes = new AttributeKey(name, tmp$ret$1);
    var tmp_2 = ContentNegotiationConfig$_init_$ref_1ne3ob();
    ContentNegotiation = createClientPlugin('ContentNegotiation', tmp_2, ContentNegotiation$lambda);
  }
}
function JsonContentTypeMatcher() {
}
protoOf(JsonContentTypeMatcher).f6b = function (contentType) {
  if (contentType.w3w(Application_getInstance().c3v_1)) {
    return true;
  }
  var value = contentType.v3w().toString();
  return Application_getInstance().w3v(value) && endsWith(value, '+json', true);
};
var JsonContentTypeMatcher_instance;
function JsonContentTypeMatcher_getInstance() {
  return JsonContentTypeMatcher_instance;
}
function get_DefaultIgnoredTypes() {
  _init_properties_DefaultIgnoredTypesJs_kt__rjtdk1();
  return DefaultIgnoredTypes;
}
var DefaultIgnoredTypes;
var properties_initialized_DefaultIgnoredTypesJs_kt_65g2xt;
function _init_properties_DefaultIgnoredTypesJs_kt__rjtdk1() {
  if (!properties_initialized_DefaultIgnoredTypesJs_kt_65g2xt) {
    properties_initialized_DefaultIgnoredTypesJs_kt_65g2xt = true;
    // Inline function 'kotlin.collections.mutableSetOf' call
    DefaultIgnoredTypes = LinkedHashSet_init_$Create$();
  }
}
//region block: post-declaration
protoOf(ContentNegotiationConfig).g4n = register$default;
//endregion
//region block: init
JsonContentTypeMatcher_instance = new JsonContentTypeMatcher();
//endregion
//region block: exports
export {
  get_ContentNegotiation as get_ContentNegotiationcp59ye9rorjc,
};
//endregion

